import { useMutation } from '@tanstack/react-query'

import {
  updateIntegrationOnPulverization,
  UpdateIntegrationOnPulverizationPayload,
} from '@/services/update-pulverization-files'

export const UPDATE_INTEGRATION_ON_PULVERIZATION_MUTATION_KEY =
  'UPDATE_INTEGRATION_ON_PULVERIZATION'

export function getUpdateIntegrationOnPulverizationMutationKey(
  demandId: string,
) {
  return [UPDATE_INTEGRATION_ON_PULVERIZATION_MUTATION_KEY, demandId]
}

export function useUpdateIntegrationOnPulverization(
  culture: string,
  demandId: string,
  integrationType: 'john-deere',
) {
  return useMutation({
    mutationKey: getUpdateIntegrationOnPulverizationMutationKey(demandId),
    mutationFn: async (payload: UpdateIntegrationOnPulverizationPayload) =>
      updateIntegrationOnPulverization(
        culture,
        demandId,
        integrationType,
        payload,
      ),
  })
}
